
function getMetaObjColors() {


    var productQuery = () => `
        query {
        metaobjects(type: "color_codes", first: 250) {     
            edges {
            node {
                ... on Metaobject {
                fields {
                    key
                    type
                    value
                }
                }
                handle
            }
            }    
        }
        }
    `;                 


    var options = {
        method: "post",
        headers: {
            "Content-Type": "application/graphql",
            "X-Shopify-Storefront-Access-Token": '1cfc21e8bc8084992c01dd7da62703ba'
        },
        body: productQuery()
    };


    fetch('https://feelathomegr.myshopify.com/api/graphql.json', options)
        .then(res => res.json())
        .then(render => {
            var response = render;
            let stylez = '';
            let edges = response.data.metaobjects.edges;
            
            for(let i in edges) {
                let temp = `[data-color="${edges[i].node.fields[1].value}"] { background-color: ${edges[i].node.fields[0].value}} `;
                stylez += temp;
            }

            let style_el = document.createElement('style');
            style_el.classList.add('swatch-colorz');
            style_el.innerHTML = stylez;
            document.getElementsByTagName('head')[0].appendChild(style_el);
        }); 
    }


getMetaObjColors();	

